var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","overflow-y":"auto"}},[_c('div',{ref:"container",style:({'height': _vm.height,'width':_vm.width})})])}
var staticRenderFns = []

export { render, staticRenderFns }